import { Tag, TTagVariant } from '@ui';
import React from 'react';
import { useIntl } from 'react-intl';

type TState = 'pending' | 'invited' | 'declined' | 'approved';

const STATE_MAP: Record<TState, TTagVariant> = {
  approved: 'success',
  invited: 'warning',
  pending: 'info',
  declined: 'danger',
} as const;

interface StaffStateTegProps {
  state: TState;
}

const StaffStateTeg: React.FunctionComponent<StaffStateTegProps> = ({ state }) => {
  const { formatMessage } = useIntl();
  return <Tag variant={STATE_MAP[state]}>{formatMessage({ id: `pairing_state_${state}` })}</Tag>;
};

export default StaffStateTeg;
